<script type="text/javascript">
  export default {
    props: ['type', 'pc', 'website'],
    data() {
      return {
        default_content: {
          type: 'offices',
          title: 'Offices',
          active: 1,
          image: '',
          color: 'gray-100',
          opacity: '',
          pad_t: '5',
          pad_r: '0',
          pad_b: '5',
          pad_l: '0',
          icon: 'ri:building-4-line',
          icon_color: 'revinre',
          h2: 'REVINRE Offices',
          h2_color: '',
          h2_desc: 'Below you will find a list of our office locations along with our agents associated with each.',
          h2_desc_color: '',
          office_bg: 'white',
          office_title_color: '',
          office_text_color: '',
          pre_btn: [],
          offices: [
            {
              image: '',
              image_alt: '',
              title: '',
              address: '',
              city: '',
              state: '',
              zip_code: '',
              email: '',
              phone: '',
              btn_color: 'revinre',
              btn_full_width: 0,
              btn_new_tab: 1,
              btn_pre_icon: '',
              btn_text: 'Branch Page',
              btn_post_icon: '',
              btn_url: '',
              btn2_color: 'revinre',
              btn2_full_width: 0,
              btn2_new_tab: 1,
              btn2_pre_icon: '',
              btn2_text: 'Branch Agents',
              btn2_post_icon: '',
              btn2_url: '',
            },
          ],
          post_btn: [],
        },
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }
      if(!this.pc.pre_btn) { this.pc.pre_btn = []; this.$forceUpdate(); }
      if(!this.pc.post_btn) { this.pc.post_btn = []; this.$forceUpdate(); }
      if(!this.pc.offices) { this.pc.offices = []; this.$forceUpdate(); }
    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section background and padding :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String" v-model="pc.image" Title="Background image URL :"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" Title="Background color :" :Options="theme_colors" v-model="pc.color"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="Number" v-model="pc.opacity" Min="0" Max="10" Title="Background color opacity :" v-tippy content="Background color transparency (0 through 10)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_t" Min="0" Max="20" Title="Top padding :" v-tippy content="Padding for the top of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_r" Min="0" Max="20" Title="Right padding :" v-tippy content="Padding for the right of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_b" Min="0" Max="20" Title="Bottom padding :" v-tippy content="Padding for the bottom of the section (0 through 20)"></w-field>
          </div>
          <div class="col-sm-3">
            <w-field SimpleDataType="Number" v-model="pc.pad_l" Min="0" Max="20" Title="Left padding :" v-tippy content="Padding for the left of the section (0 through 20)"></w-field>
          </div>
        </div>
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Section H2 title :</h6>
        <div class="row">
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.icon" Title="Section icon :" v-tippy content="Section icon"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.icon_color" Title="Section icon color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String" v-model="pc.h2" Title="H2 title :" v-tippy content="Section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_color" Title="H2 title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="Textarea" v-model="pc.h2_desc" Title="H2 description :" v-tippy content="Section description appearing below the section title"></w-field>
          </div>
          <div class="col-sm-6">
            <w-field SimpleDataType="String List, Single" v-model="pc.h2_desc_color" Title="H2 description color : " :Options="theme_colors"></w-field>
          </div>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Top buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.pre_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.pre_btn" :key="'f1'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.pre_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.pre_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>
        
        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Office Details :</h6>
        <div class="row">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.office_bg" Title="Office background color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.office_title_color" Title="Office title color : " :Options="theme_colors"></w-field>
          </div>
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.office_text_color" Title="Office text color : " :Options="theme_colors"></w-field>
          </div>
        </div>



        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Offices :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.offices">
            <transition-group tag="div">
              <div v-for="(option, option_i) in pc.offices" :key="'f2'+option_i" class="border-bottom border-light py-4">
                <div class="row">
                  <div class="col">
                    <w-field SimpleDataType="String" v-model="option.title" Title="Title : "></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.offices.splice(option_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <label>.</label>
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String" v-model="option.image" Title="Image URL :"></w-field>
                  </div>
                  <div class="col-sm-6">
                    <w-field SimpleDataType="String" v-model="option.image_alt" Title="Image ALT text :"></w-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="option.address" Title="Address :"></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="option.city" Title="City : "></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="option.state" Title="State : "></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="Number" v-model="option.zip_code" Title="Zip Code : "></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="String" v-model="option.email" Title="Email : "></w-field>
                  </div>
                  <div class="col-sm-4">
                    <w-field SimpleDataType="Phone" v-model="option.phone" Title="Phone : "></w-field>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn_color" Title="Button color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn_full_width" Title="Button full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn_new_tab" Title="Button new tab : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_pre_icon" Title="Button pre icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_text" Title="Button text :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_post_icon" Title="Button post icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn_url" Title="Button URL :"></w-field>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn2_color" Title="Button 2 color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn2_full_width" Title="Button 2 full width : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String List, Single" v-model="option.btn2_new_tab" Title="Button 2 new tab : " :Options="[{name:'Yes',value:1},{name:'No',value:0}]"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_pre_icon" Title="Button 2 pre icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_text" Title="Button 2 text :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_post_icon" Title="Button 2 post icon :"></w-field>
                  </div>
                  <div class="col-sm-3">
                    <w-field SimpleDataType="String" v-model="option.btn2_url" Title="Button 2 URL :"></w-field>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.offices.push({
            image: '',
            image_alt: '',
            title: '',
            address: '',
            city: '',
            state: '',
            zip_code: '',
            email: '',
            phone: '',
            btn_color: 'revinre',
            btn_full_width: 0,
            btn_new_tab: 1,
            btn_pre_icon: '',
            btn_text: 'Branch Page',
            btn_post_icon: '',
            btn_url: '',
            btn2_color: 'revinre',
            btn2_full_width: 0,
            btn2_new_tab: 1,
            btn2_pre_icon: '',
            btn2_text: 'Branch Agents',
            btn2_post_icon: '',
            btn2_url: '',
          }); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add office</button>
        </div>

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Bottom buttons :</h6>
        <div class="form-group">
          <draggable handle=".handle" v-bind="{animation: 200}" v-model="pc.post_btn">
            <transition-group tag="div">
              <div v-for="(btn, btn_i) in pc.post_btn" :key="'f2'+btn_i">
                <div class="row m-0 align-items-end">
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.pre_icon" Title="Pre icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.text" Title="Text :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String" v-model="btn.post_icon" Title="Post icon :"></w-field>
                  </div>
                  <div class="col-2 p-0">
                    <w-field SimpleDataType="String List, Single" v-model="btn.color" Title="Color : " :Options="theme_colors"></w-field>
                  </div>
                  <div class="col p-0">
                    <w-field SimpleDataType="String" v-model="btn.url" Title="URL :"></w-field>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white" type="button" v-tippy content="Delete" @click="pc.post_btn.splice(btn_i, 1); $forceUpdate()"><Icon icon="ri:delete-bin-line"></Icon></button>
                  </div>
                  <div class="_w-40 pb-2">
                    <button class="btn btn-white handle" type="button" v-tippy content="Drag to arrange"><Icon icon="ri:drag-move-2-fill"></Icon></button>
                  </div>
                </div>
              </div>
            </transition-group>
          </draggable>
          <button class="btn btn-sm btn-primary" type="button" @click="pc.post_btn.push({color: '', pre_icon: '', text: '', post_icon: '', url: ''}); $forceUpdate()"><Icon icon="ri:add-line" height="18"></Icon> Add button</button>
        </div>

      </div>
    </div>

    <div v-else class="container-fluid">
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" :style="'background-image: url('+(pc['image'] ? fullurlencode(pc['image']) : '')+')'"></div>
      <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1" :class="'bg-'+pc['color']+' _o-'+pc['opacity']"></div>
      <div class="container-fluid m_py-35" :class="'pt-'+pc['pad_t']+' pr-'+pc['pad_r']+' pb-'+pc['pad_b']+' pl-'+pc['pad_l']">

        <div v-if="pc['icon'] || pc['h2'] || pc['h2_desc']" class="text-center _w-m-900 mx-auto mb-5">
          <Icon v-if="pc['icon']" :icon="pc['icon']" height="45" class="mb-2" :class="'text-'+pc['icon_color']"></Icon>
          <h2 v-if="pc['h2']" class="mb-3" :class="'text-'+pc['h2_color']">{{pc['h2']}}</h2>
          <p v-if="pc['h2_desc']" class="text-pre-wrap" :class="'text-'+pc['h2_desc_color']">{{pc['h2_desc']}}</p>
        </div>

        <div v-if="pc['pre_btn'] && pc['pre_btn'].length" class="text-center mb-5">
          <a v-for="(btn, btn_i) in pc['pre_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

        <div class="row">
          <div v-for="(office, office_i) in pc['offices']" :key="office_i" class="col-sm-6 mb-4">
            <div class="card h-100 overflow-hidden" :class="'bg-'+pc['office_bg']">
              <div class="row m-0">
                <div v-if="office['image']" class="col-sm-5 p-0">
                  <img :src="formatImage(office['image'])" :alt="office['image_alt']" class="w-100 h-100 object-fit">
                </div>
                <div class="col-sm-7 p-0">
                  <div class="p-4">
                    <h3 v-if="office['title']" class="mb-3" :class="'text-'+pc['office_title_color']">{{office['title']}}</h3>
                    <div v-if="office['address'] || office['city'] || office['state'] || office['zip_code']" class="row mx-0 mb-2" :class="'text-'+pc['office_text_color']">
                      <div class="_w-15"><Icon icon="ri:road-map-line" height="20" class="text-black" /></div>
                      <div class="col">{{ office['address'] }}<br>{{ office['city'] }} {{ office['state'] }} {{ office['zip_code'] }}</div>
                    </div>
                    <div v-if="office['email']" class="row mx-0 mb-2" :class="'text-'+pc['office_text_color']">
                      <div class="_w-15"><Icon icon="ri:mail-line" height="20" class="text-black" /></div>
                      <div class="col">{{ office['email'] }}</div>
                    </div>
                    <div v-if="office['phone']" class="row mx-0 mb-2" :class="'text-'+pc['office_text_color']">
                      <div class="_w-15"><Icon icon="ri:phone-line" height="20" class="text-black" /></div>
                      <div class="col">{{ formatPhone(office['phone']) }}</div>
                    </div>
                    <div class="mt-4">
                      <a v-if="office['btn_text'] || office['btn_pre_icon'] || office['btn_post_icon']" :href="office['btn_url']" class="btn" :class="'btn-'+office['btn_color']+(office['btn_full_width'] ? ' btn-block' : '')" :target="office['btn_new_tab'] ? '_blank' : ''">
                      <Icon v-if="office['btn_pre_icon']" :icon="office['btn_pre_icon']" height="20"></Icon>
                      {{ office['btn_text'] }}
                      <Icon v-if="office['btn_post_icon']" :icon="office['btn_post_icon']" height="20"></Icon>
                    </a>
                    <a v-if="office['btn2_text'] || office['btn2_pre_icon'] || office['btn2_post_icon']" :href="office['btn2_url']" class="btn" :class="'btn-'+office['btn2_color']+(office['btn2_full_width'] ? ' btn-block' : '')+((office['btn_text'] || office['btn_pre_icon'] || office['btn_post_icon']) && !office['btn2_full_width'] ? ' ml-3' : '')" :target="office['btn2_new_tab'] ? '_blank' : ''">
                      <Icon v-if="office['btn2_pre_icon']" :icon="office['btn2_pre_icon']" height="20"></Icon>
                      {{ office['btn2_text'] }}
                      <Icon v-if="office['btn2_post_icon']" :icon="office['btn2_post_icon']" height="20"></Icon>
                    </a>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="pc['post_btn'] && pc['post_btn'].length" class="text-center mt-5">
          <a v-for="(btn, btn_i) in pc['post_btn']" :key="btn_i" v-if="btn['text'] || btn['pre_icon'] || btn['post_icon']" class="btn btn-lg mb-3 mx-3" :class="'btn-'+btn['color']" :href="btn['url']" target="_blank">
            <Icon v-if="btn['pre_icon']" :icon="btn['pre_icon']" height="20"></Icon>
            <span v-if="btn['pre_icon'] && btn['text']" class="border-left mx-3"></span>
            {{ btn['text'] }}
            <span v-if="btn['post_icon'] && btn['text']" class="border-left mx-3"></span>
            <Icon v-if="btn['post_icon']" :icon="btn['post_icon']" height="20"></Icon>
          </a>
        </div>

      </div>
    </div>
  </section>

</template>
